import styled from "styled-components";

export const SInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
